import React from "react";

import analytics from "./analytics";

export default function useGoogleAnalytics(): void {
  
  React.useEffect(() => {
    analytics.init();
  }, []);
}
